import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistroService } from 'src/app/registro/registro.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-consulta-registro',
  templateUrl: './modal-consulta-registro.component.html',
  styleUrls: ['./modal-consulta-registro.component.scss']
})
export class ModalConsultaRegistroComponent implements OnInit {
  orgaoDeferimento: any;
  mensagemExibir: any;
  linkExibir: string;
  eventoQtd: any;
  idEvento: any;
  dadosCarregados: boolean;
  errorDados: boolean;
  protocoloDigitado: any;
  loginAuth: string;

  @ViewChild('pesquisaProtocolo') pesquisaProtocolo:ElementRef;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private registroService: RegistroService
  ) { }

  idNaturezaJuridica: any;
  descNaturezaJuridica: any;

  ngAfterViewInit() {
    setTimeout(() => this.pesquisaProtocolo.nativeElement.focus());
  }  

  ngOnInit() {
    this.dadosCarregados = false;
    this.errorDados = false;

    this.loginAuth = sessionStorage.getItem('loginAuth');
  }

  pesquisarProtocolo() {
    
    this.registroService.orgaoRegistroPesquisa(this.protocoloDigitado.toUpperCase())
      .then((data) => {  
        this.idNaturezaJuridica = data.dadosRedesim.fcpj.codNaturezaJuridica;
        this.orgaoDeferimento = data.dadosRedesim.orgaoResponsavelDeferimento;
        this.eventoQtd = data.dadosRedesim.fcpj.codEvento.length;
        for (let i = 0; i < data.dadosRedesim.fcpj.codEvento.length; i++) {
          this.idEvento = data.dadosRedesim.fcpj.codEvento[i];
        }
        this.defineOrgao(this.orgaoDeferimento);
        this.dadosCarregados = true;
        this.errorDados = false;
      })
      .catch(error => {
        this.dadosCarregados = false;
        this.errorDados = true;
      });
  }

  defineOrgao(orgaoDeferimento) { 
    if (orgaoDeferimento == 'JCSP') {  

      this.mensagemExibir = `Esse protocolo de referência ${this.protocoloDigitado} é de responsabilidade de deferimento por parte da JUCESP - Junta Comercial de São Paulo. Para iniciar o processo acesse o sistema de registro clicando`;

      if (this.idEvento == 101 && (this.idNaturezaJuridica == 2062 || this.idNaturezaJuridica == 2135 || this.idNaturezaJuridica == 2305 )) {
        this.linkExibir = environment.linkRegistro + this.loginAuth;
      } else if (this.idEvento == '517' || this.idEvento == '247' || this.idEvento == '' ) {
        this.linkExibir = environment.linkRegistro + this.loginAuth;
      } else {
        this.linkExibir = environment.linkVRE + this.loginAuth;
      }

    } else if (orgaoDeferimento == 'CARTSP') {
      
      this.mensagemExibir = `Esse protocolo de referência ${this.protocoloDigitado} é de responsabilidade de deferimento por parte do cartório. Para iniciar o processo de registro acesse clicando`;
      if(environment.production){
        this.linkExibir = environment.linkCartorio
      } else {
        this.linkExibir = environment.linkCartorio + this.loginAuth;
      }
      
    } else if (orgaoDeferimento == 'OABSP') {

      this.mensagemExibir = `Esse protocolo de referência ${this.protocoloDigitado} é de responsabilidade de deferimento por parte do OAB - Ordem dos Advogados do Brasil. Para iniciar o processo de registro acesse clicando`;
      this.linkExibir = environment.linkOab;

    } else if (orgaoDeferimento == 'RFB' || orgaoDeferimento == 'RFBSP') { 
      
      this.mensagemExibir = `Esse protocolo de referência ${this.protocoloDigitado} é de responsabilidade de deferimento por parte do Receita Federal. Para iniciar o processo de registro acesse clicando`;
      this.linkExibir = 'https://www.receita.fazenda.gov.br';

    }
  }

  limpaCampos() {    
    this.mensagemExibir = false;
    this.dadosCarregados = false;
    this.errorDados = false;
    this.protocoloDigitado = '';
    this.dadosCarregados = false;
    this.pesquisaProtocolo.nativeElement.value = '';
    this.pesquisaProtocolo.nativeElement.focus();
  }  

}
